import React from "react";
import { V2_ConvertSecondToTimeCodeString } from "../../../../utils/timecodev2";
class TimeCodeSequence extends React.Component
{
    constructor(props)
    {
        super(props);

        this.handleSliderSettings = this.handleSliderSettings.bind(this);
        this.state = {timecode : this.getMinMax(this.props.timecode) };

    }

    handleSliderSettings(event)
    {
        const timecode = Number(event.target.value);
        this.setState( {timecode : timecode});

        if (this.props.onMove) this.props.onMove(timecode);
        
        
    }

    getMinMax (timecode)
    {
        var timecode2 = Math.max(this.props.in, timecode);
        return Math.min(this.props.out, timecode2);


    }

    componentDidUpdate(prevProps)
    {
        const timecode2 = this.getMinMax(prevProps.timecode)
        if (timecode2 !== this.state.timecode)
            this.setState({timecode: timecode2})
    }
    simplifyTimeCode(tc)
    {
        var timecode =  tc.replace(/^(00:)+/, "");
        if (timecode.length === 1) timecode = "0:0" + timecode;
        if (timecode.length === 2) timecode = "0:" + timecode;
        return timecode;
    }

    render()
    {
        if (!this.props.timecodeasset) return (<></>);


        

        const num =  "viid" in this.props.timecodeasset?this.props.timecodeasset.vinum:this.props.timecodeasset.asnum;
        const den = "viid" in this.props.timecodeasset?this.props.timecodeasset.viden:this.props.timecodeasset.asden;
        const timecode = "viid" in this.props.timecodeasset?this.props.timecodeasset.vitimecode:this.props.timecodeasset.astimecode;
        const dropframe =  "viid" in this.props.timecodeasset?this.props.timecodeasset.vidropframe:this.props.timecodeasset.asdropframe;

        const tcin = V2_ConvertSecondToTimeCodeString(this.props.in,num,den,dropframe,timecode);
        const tcout = V2_ConvertSecondToTimeCodeString(this.props.out,num,den,dropframe,timecode);

        var tcbefore = V2_ConvertSecondToTimeCodeString(this.state.timecode -this.props.in,num,den,dropframe,timecode);
        var tcafter = V2_ConvertSecondToTimeCodeString(this.props.out - this.state.timecode,num,den,dropframe,timecode);

        tcbefore = this.simplifyTimeCode(tcbefore);
        tcafter = this.simplifyTimeCode(tcafter);
        return (
            <div style={{
                display: "flex",
                width: "100%",
                height: "20px",
                textAlign: "center",
                fontSize: "13px",
                marginTop: "5px",
                marginBottom: "5px",
            }}>
                <div style={{
                    width: "80px",
                    flexShrink: 0,
                    overflow: "hidden",
                    paddingTop:"3px"
                }}>
                    {tcin}
                </div>

                <div style={{
                    flex: 1,
                    minWidth: 0,
                }}>

                        <div style={{
                            display: "flex",
                            width: "100%",
                            height: "9px",
                            fontSize: "8px",
                        }}>
                            <div style = {{textAlign:"left",width:"50%",height:"100%"}}>
                                {tcbefore}
                            </div>
                            <div style = {{textAlign:"right",width:"50%",height:"100%"}}>
                                {tcafter}
                            </div>
                        </div>
                        <input type="range" min={this.props.in}  
                            className= "sliderSettings"
                            style={{background:"inherit"}} 
                            onInput={this.handleSliderSettings} 
                            onChange={this.handleSliderSettings} 
                            value={this.state.timecode} 
                            max={this.props.out}
                            step={0.001}
                        />
                    
                </div>

                <div style={{
                    width: "80px",
                    flexShrink: 0,
                    overflow: "hidden",
                    paddingTop:"3px"
                }}>
                    {tcout}
                </div>
            </div>        
    )
    }
}


export default TimeCodeSequence;